export const LOCATION_THEMES: Readonly<Record<string, Readonly<Record<string, string>>>> = {
	'12ae52f4-806c-4605-9643-908053b482ab': {
		'--color-main-500': '#df0613',
	},
}
